// src/components/Navbar.js
import { Navbar, Nav } from 'react-bootstrap';
import './Navbar.css'; // Import the updated CSS
import logo from '../assets/images/logo.png'; // Import the Freight Ops logo

const NavigationBar = () => {
  return (
    <Navbar collapseOnSelect expand="sm" bg="light" variant="light" fixed="top" className="navbar-custom">
      <Navbar.Brand href="#">
        <img
          src={logo}
          alt="Freight Ops TMS Logo"
          className="navbar-logo"
        />
      </Navbar.Brand>

      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        {/* Left-aligned links */}
        <Nav className="me-auto">
          <Nav.Link href="#about">About</Nav.Link>
          <Nav.Link href="/contact"
            target="_blank" rel="noopener noreferrer"
          >
            Contact
          </Nav.Link>
        </Nav>

        {/* Right-aligned TMS App link */}
        <Nav className="ms-auto">
          <Nav.Link
            href="/tms/login"
            target="_blank"
            rel="noopener noreferrer"
            className="tms-app-link"
          >
            Log In
          </Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavigationBar;
